import "./NavBar.css";
import { Link, Routes, Route, Navigate } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import SigninSignup from "./Signin_Signip_page";
import { ChevronDownIcon, HamburgerIcon } from "@chakra-ui/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-regular-svg-icons";
import { faFolder } from "@fortawesome/free-regular-svg-icons";
import { useEffect, useState } from "react";
import { LoginContext } from "../ProductSection/Context/Context";
import { useContext } from "react";

import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Image,
} from "@chakra-ui/react";
import { Button, ButtonGroup } from "@chakra-ui/react";
import { IconButton } from "@chakra-ui/react";

function NavBar() {
  // let wishhlistformlocal = localStorage.getItem("wishlistdata");
  // let len_wish = wishhlistformlocal.length;
  // let cartformlocal = localStorage.getItem("cartdata");
  // let len_cart = cartformlocal.length;
  // const [wishlistlen, setwishlistlen] = useState(len_wish);
  // const [cartlen, setcartlen] = useState(len_cart);
  const [current, setcurrent] = useState(false);
  const [text, setText] = useState("");
  const [products, setProducts] = useState([]);

  let { fn, valu } = useContext(LoginContext);

  let navigate = useNavigate();
  const linkstyle = {
    textDecoration: "none",
    color: "gray",
  };

  const fetchData = async () => {
    let newWord = text.charAt(0).toUpperCase() + text.slice(1);
    let res = await fetch(
      `https://tata-cliq-server.onrender.com/products?q=${newWord}`
    );
    let data = await res.json();
    if (data.data) {
      setProducts(data.data);
    } else {
      setcurrent(false);
    }
  };

  function handinginputbox() {
    if (text.length > 1) {
      setcurrent(true);
    }

    if (text.length == 1) {
      setcurrent(false);
    }

    if (text == "") {
      setcurrent(false);
    }
  }

  function clickoninputdrop(targ, title) {
    console.log(targ);

    document.getElementById("right_lower_box_third_input_box_id").value = "";

    setcurrent(false);

    navigate(`/product/${targ}`);
  }

  return (
    <>
      <div id="main_navbar">
        <div id="navbar_left_box">
          <Link to="/">
            {" "}
            <img id="img_of_logo" src="/Tata_Assets/logo.png"></img>
          </Link>
        </div>
        <div id="navbar_left_bar">
          <Menu>
            <MenuButton
              as={IconButton}
              aria-label="Options"
              icon={<HamburgerIcon />}
              // variant="outline"

              colorScheme="gray"
              bg={"gray"}
            >
              Category
            </MenuButton>
            <MenuList>
              <MenuItem minH="48px">
                <Image
                  boxSize="2rem"
                  borderRadius="full"
                  src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAoHCBYWFRgVFRUYGBgaGBwaGhoYHBgaGBkaHBgZHBoYGBocIS4lHCErIRgaJjgmKy8xNTU1GiQ7QDs0Py40NTEBDAwMEA8QHxISHzQrJCQxMTQ0NDQ0NDQ0NDE0NDE0NDQ0NDQ0NDQ0NDQ0NDQxNDQ0NDQ0NDQ0NDQ0NDQ0NDQxNP/AABEIAQYAwAMBIgACEQEDEQH/xAAcAAAABwEBAAAAAAAAAAAAAAAAAQIDBAUGBwj/xABCEAACAQIDBAUJBgQGAwEBAAABAgADEQQSITFBUWEFBiJxgQcTMnKRobHB8BQjQlKy0WKCkrMzNGNzosJT4fEkQ//EABkBAAMBAQEAAAAAAAAAAAAAAAABAwIEBf/EACQRAAIBAwQCAwEBAAAAAAAAAAABAgMRMRIhMkFRcQQigWET/9oADAMBAAIRAxEAPwDbFI3TT70aD0CP+Qk0nlGUP3h0/APex/aOpxIUFaRJVN3DbzhVdbeEXfQacbbdddh74KvzElDsvW69jdUdpvWPxMssJ6N+BlfiB2j6x+cscPs2b9edv2jlhGKWX7Hwd/GFbdbb9e6DmRpu+ucBHt3TJYFt1tRt5/8A2DTbbT58bQd1774NP5fdAAWG8abvrjEsf6vr3Q78SeUjYtyFJBOax0Hd9GJsaIXTdS1NrG1xr+3edndMFSq1c5es7OiKb2HZFxYHLcA5deJNh4SajVqlTttfMWWnsfVbHPlLKqkC4FrHU7Y/g+hGNRKVs5uGOZm/DazuBYEA8QL3sN05pfZ7HVH6Lc2HVPDBKC2UjdqAGOXs6jcbg6brzQRjD0AiKg2AAC+3TeecevO2CtFI45S1SbFQQQTRkqOsWHD0WuNmt+FjqfZec0q4UVamRC4bMH2EKl7ZizDaCubZbW067VphlKnUEEHuM5hj+jslQ0arZNbq+oVkN7ZrbQTptsCW5Tlrx3TOmhLKND1azhXpu2ZkqMO1YHKLFdBsBWx7mmgv+LcN3dv8LTCdLI6KrspVkDBKiEFyGA/FtcDYLi+u83l31WxDmkGqZrXsoJvYLpfnrfju4TMZb6Rzg7ajQd427Bw5e68LKdm/bf5/KAcxt2cuXLjC/Vv+uEqSIJSR00qEfwC39REmlYwo+82bFHvJEvPBzUl9h6+g5bfhDqDZ3iKA9LT/AN7oKm7vExHspV6GK+1u8/GWGG9HlfWV9fae/wCcsMNs5X1hLCMU8se037N0F/bugHC/dBffvmCwCeff+8Plu+tLwr777YLfhgAxjcUlNHqO2VEUsTyG/nwnHOnPKLiMQxXDsKKbrAecIvvc6C/LXmZr/Kn09TpYc4dwzPVU2C2AAB9Nid19LTi/QvRtTEMVp2LgXsdNOP1xlIpWux79Fkel8V2/vnu3pWdrnvseYjVDrNjKTFkrurG1yDwFhcG4Jk+r1Fxirmyg322MrX6vYoE5qTHXhzEE4DcZmn6v+VXF0mArn7Qmwh8qMOauq/EHwnZurvT1HGUhVpHkyG2ZG/KwBNuR2EaiecG6AxIGbzD5RqdNdlzN75G+j3aq2Ip1AqIMlRSGLOCCVXhodb3uLbNZpNPBiUWsnahDhCHAyFKjrBhqL071lzW9Gxs2Y6WUjj7NNZbzL9a8aqC7lQq6Wa9ixHIEnTTQcZibSi2zUE3JJGBxlZFUU6Lu7XILhmyKRc2GxSDqLjhfv3PV5i9JC5voNbAZhuOmns4TIdH9EVmHnEpKHOaymwIRiDrcWuLDXbt4zd9D4bJSRD+FVU94AuL8L3nHSi9VzrqyWmyJ3ffl9cYWv8317oYPE93784L79+y06DmGisYW2c+oPiYC8YWr95b+AeHaMvPBz03eRNYDTlt+u+0RVOo7x8YRbu0iajajvHxmI4Zup0N1zqfW+cscMOzbdcysrNqfW+cs8MOzbjCXXozSy/Y8OF9kF98A1000h33zBYL2awEboPDbEtw3wA4t5Z8O/wBrptrlaiABuBV3zW/qEi+TRAlc5hcslh7bzceULokYpkRGy1KasdVYqQxWwJX0fR267ZWdROjshqh1tUVgh2GwtfQ87j3RuS02KwhK6Zt0W4kOpSUGVfTeIxCg5EqWsfQZU15tlZte60gdWlxLteqz5eD5WN7bmAGzZskmtjoT3L6pT0NtkjeS3ofzIxbWsrYlkT1EudPFyP5ZlMbisV9oZb1QgZhZCo0BtsKm99u2dX6AphaCAG+hJNrXYsSxtzYmVpqxz1ndFpBBBKnOFObdca4fEU0J0BLG+o7R003mwIHfOi1WsCddBfTU6cBOW9NVM9W69l7AAm+YXJscouRpmsSJGs9i1BXdzUdCYikLU0cZst8o1sL2NraaHdLsDdfT60lL0J0OlNQ4FnO03JJO8knb3y7A3TMb23HO19geOz6vBf8AF4Wh7eGkK++MwU5eR0q/fFeKDw7TQM0j4Z/v2H+mvh22+Pyl6vE5KDvIuM2m7T3wOdR6w+MQp7tNnOG57Q9YfGYhhlq2UN1DqfW+ctcL6NucqX2/zfOWuE9AcYS69GaWX7HwOUPnuhDl4w/hMFgj3d0SffDP/wAhQGU3TeDvZgDYjI5Ghy3uNfaPESgw1ZaeJZAMudEYA7yt0PuCzbsN27fOa9eqXmcQtddlwp4Kci2twGhmXHcvCe1vBtwQ66yHWxyJYMcovpoTf2D3zJp1pYUiRYtl0O7xkCqld0V67Kc2oDOwsDqNm+KxSLvg13nqbsWQg7ddx5TZ9HD7pPUX4CcTwuKq0aiKoulTYisXVnJsMpIvcki/G87hh6eVVXgoHsFpSmrEK76HoIIJU5xDDS05l5q+IUnjY96gj5j6E6cZzzpinkxFQAbGzj1SMx9+khWWyZag92jUUcQoOUcB6vdfd/7ElgbpgcPjXNUKLXeopF7jss2YnskA+iZu0NwOMzCV7jnHTYWe7ZBztpCPd3wH3TRgzhMYwzffsN3m0vy7b/H5R8xjCn79xfTIl+Xaf4/KXrcTj+PyLYHTbs2abfrZDPpL6w+IhKeezZpt+tkUfSHrD4ycOLL1soZbb/N85bYQ9kcZVNt/m+ctcIeyDCXXozS79j4PPvg5boPnBymSwL84m8JmsCSQANvDx4TN9LdeMHQuPOedf8tIB/a9wg9sLDSbwaLEVlRGd2CoqlmY7AoFyT4CYXpMpjaRfXJUCuo3gZRlvz5TIdb+v1XE02orTFOkT2gGLO4GoDNoAt9oA8bSD1T63LRHmaoPm79ltpS5uQRvW9zpqL7ISi7bFqaSf2G8Z0bXwxNgXp33XJHeI6/T9N082+oGxdfDSbTH1aZp51dQCL32rbjt4TCY/pyml/N9t/zZcqD26n61ii2+jTjbs3Xk56LGIrHEv6NAhaaH0g7KGDMp2AKwI4k33Tqs4F5OeuCYStVbEs5SqozMAWIZWJVio1tZmGmyw0ts7V0T09hsSubD1kqcQp7Q9ZT2l8RLLZHNNO+5aQQQRmAplut2GsUrbr5H9Um638bjxE1Mx/XXzwAIDGj2cwBABN9L2N7XI2i17cpipxZulyRU4VCHpk2subU6dmygWPHVtt9CZsxOd4bphcgVluhICN6RUg5bOpB7Sm3o38ZuejQwQAkmw0Jvf37e/wBwnNTdzoqqxN+jC+EF4PGVIGbMZwjffuL6ZEvyuz7+ckMJHwh++cX0yIDy1f4y9bicfx+X4Wqnns2c/rZHAO0PWHxjaHns2abd1/lHAe2vrfOTjxZetyQzvHrfOWmDPYBlUNo7/mJa4T0QZmT3XoVJbP2KxOKSmjO7KiKCWZjYADbecs6x+UyozZMIoRNe26gu3NVOiDvue7ZGfKl0+XrfZEPYp2Z7H0qlswU8QoI8SeAmBAzG83GJ0xgrXJ+P6ZxOI/xq7uODMcv9A7PukSmbxVJbQqgmithu/aiK2GU7rcxCjqNcQDItuk2WicOQCNCrk9pVBBy236j2aStNMnaY7UHbPdDtFaxnIkLpaOUqhVgykqw2MpKsO5hqIkQ7RgbfoLymYyhZahXEINz9l/B1H6gZ1Lqr1zw+NFkJSqBc0nsGsNrLbRxzGy4uBPO0fwmKam6ujFXU3VlNmUjeDAxKCZ6pvKvp6qgosG/FZbb9SNQOQufCYroPrmcZRRC+TEK1nUAWqJb/ABF4agXA2E8CI7S6XoUmezVHe9gxUtYg/hBOUEG+pHdeSnVUXZijSk9zP4nDeYrVQPw1FYbLByiM44aNf2GdE6IxJekjkoSRtQ3Q8xec1auajg5GyXJCg53Ym5LMRqSTpv8ASudt50vonC+bpIl72Ftd/P63SFN3k2sFqqtFJ5JvzghgQuUsc5nWjGDP31QX0ypfl6W/nH2kfBn72oN2VL/8t8tV4nJ8fl+Fsh2XOzZpt3X+UP8AEvrD4wkPE7NnP62QfiXvmIcWWq8kNjd9bxLPDEBAToNZWH8P1wlR186X+z4B8pIeqfNJ3uDnOnBA9udonlIKOH7ONdK43zuIrVb3z1XcH+EuSv8AxtI3nLAEcT7IVDb4fCMPoLDcTKHUtkWaPeKcSvw9STybiBtO5GaJVoHiVGsBCXPbPMCGIT+nflb698XASBDESIM0BhPpr9GJzbIT1Y1Ta9oCuT8JiSjq6kgqb3UkG2w2I4i48Z1D7RR8yUpU2Y5QQ3aVN2ubYTy+M5LTbWdl8mYD4IZrNZ3RlOvokEDuylZGrT1bmlPSF1Npl3u62KiysDrra4a22+n0JvQJHwuFRLlUC322FvhJVpmEdMbEpy1SuFaC0O0IiaMGdYyPhT99UBOmVL+xt/OOkxjCH76oDsypf2NvlqvE5Pjci3pm9rneLc7m1/lD/EO8/AwqbbLneLc+cDekPH4GTjxZapyQhvwzm/lXxhNTDUL6IjVDzLvlB8AhHiZ0gnZ9bpyPym1b48gfgpU1+L/95q32/DVHH6ZgrZ+/6MgO3aI5gye5v3jUcxwlZiSc3w7jNF5OyJCGWFFriVoOkm4Y7IDiw3GsbU6x+qsQig6QNDNQ9r3/AB/eGp0hMuvhaACAgy0bLxbCMMN0AYzVMXh958BGqx0i6B0HGBhPcfWdU8jmLuMTR4FKg/mDK36UnK0E3fkkxGXHFL6PRde8qyOPcrTLwOWDtQEOC8BkyQUIwwYV4DM0Yzgj99Vv6Nkv/Sd8fMiYNwKtXMbKcmpIA0TZf4+EtWf1OP43L8Lqk2ouTe4tzBO2G2rDx/SYxRxSG3bW9wF7S3NzwvtMdY6jx/SZKPBl6nJCTu7vkZx3yj0yuPqHeyU2HdkVfihnX3Ozu8dhnEeuON89jqzZswVwi22BUGWwI55j4zfY6JUu+gYcdRz+Uh41gQCJMrMBtt+8q6hOomi83sS03SXSOgkOl8pKRtIwgSn1EZU2Mcpm4iHERQQ0TshmE0BBNGn1imiWNxATLfA4WiuAxVeqoZ2enQocVe/nKjA7rIB7bb5naB1nZOh+qSYjoanRZ1Wo5OIViQMrtmyZv4ShCnvvunHCjIxUizKSCDuINiPaIJ3JLNyYDNV5N2I6Sw1tpNW/d9nqzILUlr1dxXmsVh62YgJWQsVNiEzgOPFSwI3gkQKN7HpWAwi44j2iAOOI9skSuCF7IeYbdIm45e2ILmdMzmPYGq4ZwoDLw/InHvmhYzLNTLYnEjs2Dp6S5ttFOY4TplFyVkefGSi7sk4EJ5xLPc50t6OvaE152jx+BmbwGDAdDZNHU6IBsYc5pG2j63GTcXGLuVU1JqyGKuy54H4GcG6WKPXqNRAFO/ZtsOgzEE7AWueGs7V1jxXm8LWfetJ7d5QhfeROG0TZTpfdH2dHx1fcYqOd/wAojAYB69UU6YuTzGgG1jc7oitU3FffNV5McCKmIdiBZKZ2gMLsygaHuMLN4KVGkrsq+nsClDE1KVMkopXKSbmxRW297GQFMseslRWxdcrawcqLCw7ICmw71MrRDfs3HBMw5iqkRh45UgU6GIlooxDmAmFGagtsjpiGMBM7X0KinD0StQhfNIRqNBkGmycMxjDO5VmZS7EM21hc2ZuZ2zq/k9qecwgHZvTdk1DHTR12MNz28Jz7rPQT7bXWmFCioRZdFuAA1hc/ivEk1uzljK8nFX2Kuklxsml6h00+2073U5XykH8WRr31/LnlMq2mo6hdGGriTV/DSQ7b2LuCoGn8Oc+yO19kWqWjBtnRjhv9Q+2F9nP/AJD9eMBwXJfa37wvsH8I/qeZdOX8OJVof0P7Mf8AyH3/ALwfZ2/P8f3hDA/wj+pv2gOC/hH9TftGoS/gnVj/AEnNM7SH/wCnE+un9pJommfo/wCYxPrp/aSXRzsuMCO2nrD4y2faO/8A6mVWAHbTvlo41Hf8jMVMMrSyvZk/KPiMmBYb3dE/5Zj7kM5MPQHfOxdcOgxiqKIXKZHzaAEHQrr3XMzb+TglQVxI2b6Z+Tybklk7/jL6s5jiNs3HUrF/Z8Bi8QAM2dUQkfjygKDyBqA2lf0x1Jr07lHSpYXsgfOeSrY3PK8ldM0Gw3RuGw7DK9Wo1Z1OhAt2Qw2g2ZNNxBjjJBUi27GTvzvzO08zDAhCOot9kCiJOHFouqbRumLRVQQKLA0Y2+2LMZcwEws9tDEO0WSDGmG6Blm68nXSJp0MXlsWXzbIDsLvmRAeRbIDND0X1Kw6pmqL52o2ru5btMdSQoNhqe/nMt5MKTM9cZbqVS7cGViygcToZ1Jmyi0nUn0FGCu5eTmfWfoOlSQvTVlIIGW5YG5tYA3Psm16ndDHDYcK/puc9TkSAAngAPG8ZqdHHEYlM1lo0mFRy1+3UGtNEttCmzMdmwbb21JRfzr7/wBpuk0leTOb5bcnpihkiCOZU/8AIvv/AGgyL+dff+0p/rHycf8AjPwNWhWjxRfzr7/2iSE/Ovv/AGh/pHyL/KfgYaUGHH3+I9df7STQNM/R/wAxiP8AcT+0k2jEi5wXpp3j4yzfaO//AKmVmC9NO8Szc6j63GYqYZWlleyJifQXvjjaJG8R6K94icdUsvhOepk9H4vF+yvwSZqpbcoPtOn7zn/lQxGbEon5KCeBYk/ACdA6OqZVNyAW7VybC1yAPcZyrrpiC+NrEkGxVBbUWRFXTldSfGOLi7JdCalrcnjooY9SqWjYiskoURKWoLaRD1CYmg2tjFPaBroQGiGi4liIANOJp+huouKxAzOBRQ7GqA5j3INfbaSvJt0WKlc4moPuqN7E2sXI0/pBv3lZ1OhWLFncFEuBTBtdltcta9xrfQ7gJiUrYHGN1dlZ0H0SmEoLSTtWN2YixZjtJ+twkojMY7XNxcDSM1MQtMorEEMwW4P4js04Saa1LUxVW4waitwfYl4n3ftB9jHFvd+0nCnFZJ2aY+DxtUvJX/Yl4n3ftEnArxPu/aWWSEUi0R8Bql5ZXfYl4n3ftCOBXif+P7Sx83CKR6Y+A1y8jZmeo/5jE+un9pJoCZncP/mMT66f2kjRll5gPTXv+Rk+u2o8f0mQujh217m/S0l4jb7f0GYqYZWlleyOfRS/ESJ04+VdTYX17ra38BJjbE7/AJSH1guUVQNdTfnaw+c56r3/AA9H4q+n6Z2vgQFZnZyWN11Yqo1JA4C1hac16TN61S2zO9u7MbTrOGwxqIGQsAc3M/kYWJvtv6M5FinDOzDYWZh3FiR8ZL47u2y08JDQMdXWIAjyCdRhC1SIcR0DSNMYGxMYxHuj94TCAmd0wiogWnQRGVFUZhkRCco7Vl0v3Awq20mqwP8AApYg+s1hcfwga85x/oHrG+F7AVXpF87KVAa5AByuLEaAaHSbrC9dMEVDWyMNzrUZh3WDD3yMou5SMlazNDUxIdL5sofsL+EgscoFtCDc7ND3SPgaadnOgLpbU3vcfi22J9usw/SHWMYnF4dUuKS1kNyNXdmClyvIGwG3bNwmGKDNlYK2xm2mw5fWsIq1RJ9o5flNuF10XqODHZTUaxEn0q152nlEqC0SrQ7wGAxJirxJgIjNM9Q/zGI/3E/tU5oWmdof4+J/3E/tU4kEi+6L9Ne5v0NJlRCWsNpv+k/vInRXpj1W/SZY0XAciZkrqxairsi0qZJAI9HTx3xnpenmQ23b+ep/aWddbKSNvhr3i8rcTWGRri5FwQONtJzTXk9SjZJJdGffFfZ8NUAynKjHMpJ1a5sbjTtNu4zj7DWdI64VzQwopFlLV3H4VD5KQzEsQTcZggGzfec3ioRsrvsJP7DyCOosQi6RxZYaDjLR0mNNAYUKCCAhpkh2i2ESICJnQhtiaB/16X9xZ3DHYnPoWIVSCQLa5iVBsTrrw1nCcA1qtM8HQ6mw9MbTu752vPn7DNkZbhip0OpUXLhiuVrXsTcOCDtA5q0nFpoWlSTTGUYHUG43SbhpCTdbZLChO+ODx5ZZKSORKw4AC8STDMQYAxszN0T/APoxPrp/ZSaRpmaH+YxPrp/apwQpGh6KPb/lb4R7EsQbqbHjyAuRGei/S/lPyjmL39x/TMVXZNotRygJi1Kkk3sSC2cWLbwVO/l+0bxOAYqxBAzKLaaHbYxdXo6nbPl7RUk8jl1NuOhPjDwT1F7D27KLYi9jca+wiR7szvi7K6OKdZ8e9XEkOCuRcgVgQQNTcg63N7+IlSRNR5Q8EUxhqgXWppe3410YHna3smZO2bSSVkai7kikNIsiEmyHAqgERthHDENABswQGCAgmiI4REQEItOy4Zx9mR1BGdEcHT8V2AFuGbU8T4Djg2zqHUJ/O4dEP/8ANmv3XzIPf/xMhWpudkvJlyUU2y9KWA5AfCSMO8crpI6aGdq2VjyHu7lkjxwxikY/ABJMIwzCMYmNkTM4f/HxJ/1R7kQTTGZnCf4lfnVP6VtEN4ND0UO0fUPxWO1hc246Rnova3qf9lkoC7jxPstJ1MMtR5Ik1mIRr/ltt3HT26xFPRyCL9gfO14nGv2DrbsrYabyQR7ot1AdmvqwA12WAJFuHpe6Y7OzowPlGwwahnAHYqK23WzEobce0w9s5kds6p5SOkcmHNHL6bKL2tY5hUuWvroo0A2kzlcZuJJpwr6wJshNAqLJiGiwYipAYgwQwIV4CATG44Y0YCYCZvPJhj7VHok6Omcd6EA+5/dMDeaLqNiMmMo/xFkP8yMB77Rxe5GsrxZ1yvIqnWP1zGaaSp5hLpSSIxTWPiABExJiiIkxiY20zWG/xK/+8f0rBBF2N4ND0Z+L1f8AsJLoi7+DfKCCYkVpZQ3iAMg45lHwkHFdJn7SKAFg2YA8DTpl7+OW1uQ5wQSXZ3I5x5T8S5xoQnsrTQgXOW5zXOU6A7r8LTIiHBNG44H1OkTBBAoKWGRBBABtoGgggAIyYIICYRMmdC1imIosN1VP1iCCCyYlhnaqm2P0FggljySUixZEEEGCCiWEEEAP/9k="
                  alt="Fluffybuns the destroyer"
                  mr="12px"
                />
                <span>Men's Wear</span>
              </MenuItem>
              <MenuItem minH="40px">
                <Image
                  boxSize="2rem"
                  borderRadius="full"
                  src="data:image/jpeg;base64,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"
                  alt="Simon the pensive"
                  mr="12px"
                />
                <span>Women's Wear</span>
              </MenuItem>
              <MenuItem minH="40px">
                <Image
                  boxSize="2rem"
                  borderRadius="full"
                  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSEbuoTHfOgCfJFHPAFK3oAmMZgbOapRufS5w&usqp=CAU"
                  alt="Simon the pensive"
                  mr="12px"
                />
                <span>Kid's Wear</span>
              </MenuItem>
              <MenuItem minH="40px">
                <Image
                  boxSize="2rem"
                  borderRadius="full"
                  src="data:image/jpeg;base64,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"
                  alt="Simon the pensive"
                  mr="12px"
                />
                <span>Footwear</span>
              </MenuItem>
              <MenuItem minH="40px">
                <Image
                  boxSize="2rem"
                  borderRadius="full"
                  src="data:image/jpeg;base64,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"
                  alt="Simon the pensive"
                  mr="12px"
                />
                <span>Electronic</span>
              </MenuItem>
              <MenuItem minH="40px">
                <Image
                  boxSize="2rem"
                  borderRadius="full"
                  src="data:image/jpeg;base64,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"
                  alt="Simon the pensive"
                  mr="12px"
                />
                <span>Home Essestials</span>
              </MenuItem>
            </MenuList>
          </Menu>
        </div>
        <div id="navbar_right_box">
          <div id="top_log">
            <img src="/Tata_Assets/logo.png" alt="logo" />
          </div>
          <div id="right_upper_box">
            <div id="right_upper_box_left_box">
              <div>
                <h1 className="upper_boxof_navbar_h1">Tata CLiq Luxury</h1>
              </div>
            </div>
            <div id="right_upper_box_right_box">
              <div>
                <h1 className="upper_boxof_navbar_h1">CLiq Cash</h1>
              </div>
              <div>
                <h1 className="upper_boxof_navbar_h1">Gift Card</h1>
              </div>
              <div>
                <h1 className="upper_boxof_navbar_h1">CLiq Care</h1>
              </div>
              <div>
                <h1 className="upper_boxof_navbar_h1">Track Orders</h1>
              </div>
              <div>
                <SigninSignup />
              </div>
            </div>
          </div>
          <div id="right_lower_box">
            {" "}
            <div className="right_lower_box_first">
              <div className="right_lower_box_first_first">
                <div id="category_box_arrow">
                  <div>
                    <h1
                      className="lowerboxof_navbar_category"
                      id="category_box"
                    >
                      Categories
                    </h1>
                  </div>
                  <div id="category_box_arrow_arrow">
                    <h1>
                      <ChevronDownIcon />
                    </h1>
                  </div>
                </div>

                <div className="dropdown-menu-category">
                  <div className="dropdown-menu-category-first">
                    <Link to="/products/Kids">
                      {" "}
                      <div className="dropdown-menu-category-first-first  h4-tag">
                        <p style={{ fontWeight: "300" }}>Women's Fashion</p>
                      </div>
                      <Link to="/products/Kids">
                        <div className="dropdown-menu-category-first-second">
                          <div>
                            <div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <a
                                    className="black-giving"
                                    style={{ fontWeight: "450" }}
                                  >
                                    Shop All Etnic Wear
                                  </a>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Kurtis & Kurtas
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Suits
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Sarees & Lehnga Sets
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Bottoms
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Blouses & Fabrics
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Dupattas
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <a
                                    className="black-giving"
                                    style={{ fontWeight: "450" }}
                                  >
                                    Shops All Western Wear
                                  </a>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Tops & Tunics
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Dresses
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Jeans
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Shirts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Trouses
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Skirts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Shorts
                                  </p>
                                </Link>
                              </div>
                            </div>
                            <div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    jackets & Blazzer
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Legging
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Capris
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    jumpsuits
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Shrugs
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Sweater
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Sweatshirts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <a
                                    className="black-giving"
                                    style={{ fontWeight: "450" }}
                                  >
                                    Activerwear & Sportships
                                  </a>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    T-shirts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    shorts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    jackets
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Truck Pnts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    innerwear
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    sets
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <a
                                    className="black-giving"
                                    style={{ fontWeight: "450" }}
                                  >
                                    Linkerie
                                  </a>
                                </Link>
                              </div>
                            </div>
                            <div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Shops all
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    sets
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    bras
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Pnties
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Lingerie
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Cammison
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    sleepswear
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    swimswear
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <a
                                    className="black-giving"
                                    style={{ fontWeight: "450" }}
                                  >
                                    shops all footwear
                                  </a>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    casual wear
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    boots
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    sneakers
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    flips flops
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    sports shoes
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    shoes
                                  </p>
                                </Link>
                              </div>
                            </div>
                            <div>
                              <div>
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    jackets & Blazzer
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Legging
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Capris
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    jumpsuits
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Shrugs
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Sweater
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Sweatshirts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <a
                                    className="black-giving"
                                    style={{ fontWeight: "450" }}
                                  >
                                    Activerwear & Sportships
                                  </a>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    T-shirts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    shorts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    jackets
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    Truck Pnts
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    innerwear
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <p
                                    className="a-a"
                                    style={{ fontWeight: "300" }}
                                  >
                                    sets
                                  </p>
                                </Link>
                              </div>
                              <div
                                className="a-a"
                                style={{ fontWeight: "300" }}
                              >
                                <Link style={linkstyle}>
                                  <a
                                    className="black-giving"
                                    style={{ fontWeight: "450" }}
                                  >
                                    Linkerie
                                  </a>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Link>
                    </Link>
                  </div>

                  <div className="dropdown-menu-category-second">
                    <Link to="/products/Kids">
                      <div className="dropdown-menu-category-second-first h4-tag">
                        <p style={{ fontWeight: "300" }}>Kid's Fashion</p>
                      </div>

                      <div className="dropdown-menu-category-second-second">
                        <div>
                          <div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <a
                                  className="black-giving"
                                  style={{ fontWeight: "450" }}
                                >
                                  Girls clothing
                                </a>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Tops
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Jeans and trouser
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Dresses
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  jumpsuits
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  skirts and other wear
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Ethnic Wear
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Matching sets
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  sleepswear
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <a
                                  className="black-giving"
                                  style={{ fontWeight: "450" }}
                                >
                                  Boys Clothing
                                </a>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  T-isrts
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Shirts
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Trouses
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Skirts
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Shorts
                                </p>
                              </Link>
                            </div>
                          </div>
                          <div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  jackets & Blazzer
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Legging
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Capris
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  inner wear
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Winter wear
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Sweater
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Sweatshirts
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <a
                                  className="black-giving"
                                  style={{ fontWeight: "450" }}
                                >
                                  Infants
                                </a>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  T-shirts
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  shorts
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  jackets
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Truck Pnts
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  jumpsuits
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <a>sets</a>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <a
                                  className="black-giving"
                                  style={{ fontWeight: "450" }}
                                >
                                  Footwear
                                </a>
                              </Link>
                            </div>
                          </div>
                          <div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Girl's footewear
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  mamthcing shortss
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  inner
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  suits
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  snw=eakerss
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  blazzer
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  track suits
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  swimswear
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link className="black-giving" style={linkstyle}>
                                shops all footwear
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  casual wear
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  boots
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  sneakers
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  flips flops
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  sports shoes
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  shoes
                                </p>
                              </Link>
                            </div>
                          </div>
                          <div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  jackets & Blazzer
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Legging
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  Capris
                                </p>
                              </Link>
                            </div>
                            <div className="a-a" style={{ fontWeight: "300" }}>
                              <Link style={linkstyle}>
                                <p
                                  className="a-a"
                                  style={{ fontWeight: "300" }}
                                >
                                  jumpsuits
                                </p>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <div className="dropdown-menu-category-third">
                    <Link to="/products/Men's Clothing">
                      <div className="dropdown-menu-category-third-first h4-tag">
                        <p style={{ fontWeight: "300" }}>Men's Fashion</p>
                      </div>
                    </Link>
                    <div className="dropdown-menu-category-third-second">
                      <div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Tops
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                t-shirts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Jeans
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Shirts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Formal shirts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Bottoms
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Jeans
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                chinos
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                sleepswear
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Boys Clothing
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                T-isrts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Shirts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Trouses
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Track pants
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Sctive wear
                              </a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                jackets & Blazzer
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                shortss
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                jogger
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                inner wear
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Winter wear
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Sweater
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Sweatshirts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Innerwear
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                T-shirts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                shorts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                jackets
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Truck Pnts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                jumpsuits
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                sets
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Footwear
                              </a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                footewear
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                mamthcing shorts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                inner
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                suits
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                snweakerss
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                blazzer
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                track suits
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                vests
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Watches
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                casual wear
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                boots
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                sneakers
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                flips flops
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                sports shoes
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Bags and Backpacks
                              </a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                track suits
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                swimswear
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                shops all footwear
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                casual wear
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                jackets & Blazzer
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Legging
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Capris
                              </p>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-menu-category-fourth">
                    <Link to="/products/Home">
                      <div className="dropdown-menu-category-fourth-first h4-tag">
                        <p style={{ fontWeight: "300" }}>Home and Kitchen</p>
                      </div>
                    </Link>
                    <div className="dropdown-menu-category-fourth-second">
                      <div>
                        <div>
                          <div>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Bedding & linene
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Bedsjheets
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Bedding sets
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Pilows and matt
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Comforters
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                quilts
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Dohar
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Kids Bedding linen
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                sleepswear
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Bath linen
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Towels
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Hand Towel
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Face towel
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Bath mats and rugs
                              </p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="a-a" style={{ fontWeight: "300" }}>
                                Rugs
                              </p>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Floor Lmaps</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Decorative Lights</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Lundry</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>coushion cover</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Rooms furninshing
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>rugs</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Sweatshirts</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Lamps and light
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>table lamps</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>cieling lamps</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>carpets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>cusion cover</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Doormats</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>sets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Footwear
                              </a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>carpets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>cusion cover</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Doormats</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>sets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Lmaps
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bedsjheets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bedding sets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Pilows and matt</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Bedding & linene
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            {" "}
                            <Link style={linkstyle}>
                              <a>casual wear</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            {" "}
                            <Link style={linkstyle}>
                              <a>boots</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Bath linen
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Towels</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Hand Towel</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Face towel</a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Home Decore</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Show piece</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                wall Decore
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>vases</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bedsjheets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bedding sets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Pilows and matt</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>carpets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>cusion cover</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Doormats</a>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-menu-category-fifth">
                    <Link to="/products/beauty & grooming">
                      <div className="dropdown-menu-category-fifth-first h4-tag">
                        <p style={{ fontWeight: "300" }}>Beauty</p>
                      </div>
                    </Link>
                    <div className="dropdown-menu-category-fifth-second">
                      <div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Fragrance Store
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>perfume</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>gift</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Deodrandts</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bodymists</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>All frangrance</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Makeup</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Eyes
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Matching sets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Naila</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Fcae</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Lips</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Skin
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>All Makeup</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Shorts</a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Mosturises</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>facial</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Eye creams</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Combo sets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Men's Skin Care</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Ntural skin care</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Derma Skin Care</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Hair
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>shampoo</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>conditioner</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>hair masks</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>hair styling</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>hair care</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>all skin</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                K-skin
                              </a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Natural Hair Color</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>All Hiar</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>inner</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Men's grooming
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>shaving</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Beard and momtchaaes</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Tools and Accesories
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Bath and Body
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                All Beauty and grooming
                              </a>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-menu-category-sixth">
                    <Link to="/products/electronics">
                      <div className="dropdown-menu-category-sixth-first h4-tag">
                        <p style={{ fontWeight: "300" }}>Gadgets</p>
                      </div>
                    </Link>
                    <div className="dropdown-menu-category-sixth-second">
                      <div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Audio store
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Headphones</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Wired Earphone</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Headsets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Neckbands</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>True wear</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Headsets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Headphones</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Spekaers
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bluetooth</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Wearabele
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>premium</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Personal Care
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Hair Dryers</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>sound</a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Hair starithner</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>hair stylers</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Trimmers</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Eplitaors</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Oral Care</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Hair curlers</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Health care
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Electric meassagers</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Health monitor</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Steamers</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Wiegh</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Thermometer</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Tech Accesories
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Fast Chargers</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Power Banks
                              </a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Cables</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Cases & Cover</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Screen Protector</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Memeory Cards</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Mobile Holders</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Tblets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Smart Home
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Lights</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Smarts Plugs</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Smarts Locks</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Powers and hands</a>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-menu-category-seventh">
                    <div className="dropdown-menu-category-seventh-first h4-tag">
                      <p style={{ fontWeight: "300" }}>Jewellery</p>
                    </div>
                    <div className="dropdown-menu-category-seventh-second">
                      <div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Golds Jewellery
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Earrings</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Chains</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Pendants</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Nceklace</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Managalsutaerra</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bnales</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Diamond Jewellery
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Earring</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Pnedats</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Nceklace</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Rings</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bnales</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Necklace</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Silver Jewellery
                              </a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Earring</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Rings</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Pendants</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Necklace</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bangles</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Toe Rings</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Sweatshirts</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Fashion Jewellery
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Earring</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Necklaces</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Pendants</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Bangles</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Rings</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Coins and bars
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Golds</a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div>
                            <Link style={linkstyle}>
                              <a>Silver</a>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-menu-category-eight">
                    <div className="dropdown-menu-category-eight-first h4-tag">
                      <p style={{ fontWeight: "300" }}>Accesories</p>
                    </div>
                    <div className="dropdown-menu-category-eight-second">
                      <div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Bags, Wallets
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>handsbags</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Sling Bags</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Backpacks</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Wallets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Clutches</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>meassagers</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Body Bags</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Watches
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Smartsphones</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>for him</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>For hers</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Eyewears
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Wallets</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>sunglasses</a>
                            </Link>
                          </div>
                        </div>

                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Reading Glasses</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Eye glasses</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Ffashion Accesories
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Belts</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Ties</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Socks</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Luggage & Trolley
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Trolley</a>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_lower_box_second">
              <div className="right_lower_box_second_first">
                {/* <h1 className="lowerboxof_navbar_brand" id="brand_box">Brands</h1> */}
                <div id="brand_box_arrow">
                  <div>
                    <h1 className="lowerboxof_navbar_brand" id="brand_box">
                      Brands
                    </h1>
                  </div>
                  <div id="brand_box_arrow_arrow">
                    <h1>
                      <ChevronDownIcon />
                    </h1>
                  </div>
                </div>

                <div className="dropdown-menu-category-brands">
                  <div className="dropdown-menu-category-brands-first">
                    <div className="dropdown-menu-category-brands-first-first h5-tag">
                      <p style={{ fontWeight: "300" }}>Women's Wear</p>
                    </div>
                    <div className="dropdown-menu-category-brands-first-second">
                      <div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="black-giving">Popular Brands</p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Utsa</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Forver 21</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Lov</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Biba</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Bomabay Pasley</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Only</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Wardrobe</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Ishin</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Vark</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Trumph</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Zuba</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Indo Era</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Zivame</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Zink London</Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Featured Brands
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Westside</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Westside</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>wan huesen</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Adidas</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Kazo</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Arelia</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Kazo</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Engamo</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Levi's</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Jaipuri kurti</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Clovia</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Soch</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>United color</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Globus</a>
                            </Link>
                          </div>
                        </div>
                        <div className="third_box_of_brands_extension">
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/13999033614366.png"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/13999033843742.png"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/15140220403742.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013524955166.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/15963080425502.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/13999034531870.png"
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-menu-category-brands-second">
                    <div className="dropdown-menu-category-brands-second-first h5-tag">
                      <p style={{ fontWeight: "300" }}>Men's Wear</p>
                    </div>
                    <div className="dropdown-menu-category-brands-second-second">
                      <div>
                        <div>
                          <div>
                            <Link style={linkstyle}>
                              <p className="black-giving">Popular Brands</p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Utsa</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Eta</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Kazo</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Engamo</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Levi's</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Puma</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Ascot</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>killer</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Raymonds</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Blackberry</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Woodlands</a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Fetaured brands
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>WestSide</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>US POLO</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>WES</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Peter Englands</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Fruits of the loom</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Flying Machine</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Celo</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>westesed</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>parx</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>spykar</a>
                            </Link>
                          </div>
                        </div>
                        <div className="third_box_of_brands_extension">
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525020702.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525086238.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525151774.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525217310.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525282846.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525348382.jpg"
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-menu-category-brands-third">
                    <div className="dropdown-menu-category-brands-third-first h5-tag">
                      <p style={{ fontWeight: "300" }}>Footwear</p>
                    </div>
                    <div className="dropdown-menu-category-brands-third-second">
                      <div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="black-giving">Popular Brands</p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>red chief</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Roush</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Toms</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Alberto</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Campus</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Luna</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Regal</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Reebok</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>London</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a></a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Aldo</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>New Ballance</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Hush Pupples</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Hoka</a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Fetaured brands
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Red Tape</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Puma</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Crocs</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Asics</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Woodlnd</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Ctawalk</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Clarks</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Metro</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Mochio</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Bata</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Leone</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Clarks</Link>
                          </div>
                        </div>
                        <div className="third_box_of_brands_extension">
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525413918.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525479454.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525544990.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/14003109986334.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525610526.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525676062.jpg"
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-menu-category-brands-fourth">
                    <div className="dropdown-menu-category-brands-fourth-first h5-tag">
                      <p style={{ fontWeight: "300" }}>Jewellery</p>
                    </div>
                    <div className="dropdown-menu-category-brands-fourth-second">
                      <div>
                        <div>
                          <div>
                            <Link style={linkstyle}>
                              <p className="black-giving">Popular Brands</p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Mia by Tanisq</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Malabar</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Jyalukkas</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>P.C Jewellery</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>P.C Chandra </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Wemen hari</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Orra</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Banglore Refinery</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Jyalukkas</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>P.C Jewellery</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>shaya</a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Fetaured Brands
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>MELLORA</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Shaya</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>claar</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Sri Pearls</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Tribe</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Izara</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Tarash</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Ahilya</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Tlisman</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>London</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>real effect</a>
                            </Link>
                          </div>
                        </div>
                        <div className="third_box_of_brands_extension">
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/26759829979166.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/13957515968542.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/13957516165150.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/13957516099614.jpg"
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="dropdown-menu-category-brands-first">
                    <div className="dropdown-menu-category-brands-first-first h5-tag">
                      <p style={{ fontWeight: "300" }}>
                        Watches and Accesories
                      </p>
                    </div>
                    <div className="dropdown-menu-category-brands-first-second">
                      <div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <p className="black-giving">Popular Brands</p>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>lavie</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Caprese</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Hide</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Lino</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Saggit</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Ammerican</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Carlton</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Skybags</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Gio</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Esbeda</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Fossil</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Da Milano</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Elle</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Addons</a>
                            </Link>
                          </div>
                        </div>
                        <div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a
                                className="black-giving"
                                style={{ fontWeight: "450" }}
                              >
                                Featured Brands
                              </a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Esbeda</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Fossil</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Da Milano</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Citzens</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Kenneth</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Lenskart</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Casion</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Tommy</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Sonata</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Caprese</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Hide</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>
                              <a>Lino</a>
                            </Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>Timex</Link>
                          </div>
                          <div className="a-a" style={{ fontWeight: "300" }}>
                            <Link style={linkstyle}>kklien</Link>
                          </div>
                        </div>
                        <div className="third_box_of_brands_extension">
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525741598.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525807134.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525872670.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013525938206.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013526003742.jpg"
                            ></img>
                          </div>
                          <div>
                            <img
                              className="third_box_of_brands_extension_div"
                              src="https://assets.tatacliq.com/medias/sys_master/images/33013526069278.jpg"
                            ></img>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="right_lower_box_third">
              <input
                id="right_lower_box_third_input_box_id"
                style={{ borderRadius: "8px" }}
                className={
                  current
                    ? "right_lower_box_third_input_box whiteoninput"
                    : "right_lower_box_third_input_box"
                }
                onChange={(event) => {
                  setText(event.target.value);
                  handinginputbox();
                  setcurrent(true);
                  if (event.target.value === "") {
                    setcurrent(false);
                  }
                  fetchData();
                }}
                onKeyDown={(ev) => {
                  if (ev.key === "Enter") {
                    let word = text;
                    if (word === "kids") {
                      word = "Kids";
                    }

                    navigate(`/products/${word}`);
                    document.getElementById(
                      "right_lower_box_third_input_box_id"
                    ).value = "";
                    fn((prev) => !prev);
                    setcurrent(false);
                  }
                }}
                placeholder="Search By Category"
              ></input>

              <div
                className={
                  current ? "hidden_box displayblock" : "hidden_box displayNOne"
                }
              >
                {products.map((elem) => {
                  return (
                    <>
                      <div className="inputdrop">
                        <h1
                          onClick={(ev) => {
                            clickoninputdrop(elem._id, elem.title);
                          }}
                        >
                          {elem.title}
                        </h1>
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
            <div className="fourth_lower_box">
              <div>
                <Link to="/myaccount">
                  <div>
                    <h1 className="icon_heart">
                      <FontAwesomeIcon icon={faHeart} />
                    </h1>
                  </div>
                </Link>
                {/* {wishlistlen > 0 ? (
                  <div className="redround heart_icon">
                    <Link to="/wishlist">
                      <h4 className="heart_icon_h4">{wishlistlen}</h4>
                    </Link>
                  </div>
                ) : null} */}
              </div>
              <div>
                <Link to="/cart">
                  <div>
                    <h1 className="icon_heart">
                      <FontAwesomeIcon icon={faFolder} />
                    </h1>
                  </div>
                </Link>
                {/* {cartlen > 0 ? (
                  <div className="redround bag_icon">
                    <Link to="/cart">
                      <h4 className="heart_icon_h4">{cartlen}</h4>
                    </Link>
                  </div>
                ) : null} */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default NavBar;
